import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { IMyAgent } from '../../../../interfaces/i-agents';
import { AlertService } from '../../../../shared/alert/alert.service';
import { SpinnerService } from '../../../../shared/spinner/spinner.service';
import { ApiService } from '../../../../services/api.service';
import { AlertEnum } from '../../../../shared/alert/alert.enum';
import { MyAgentsService } from '../services/my-agents.service';
import { AgentTableComponent } from '../../agent-table/agent-table.component';
import { AgentService } from "../../services/agent.service";

@Component({
  selector: 'app-agent-list',
  imports: [
    CommonModule,
    AgentTableComponent
],
  templateUrl: './agent-list.component.html',
  styleUrl: './agent-list.component.scss'
})
export class AgentListComponent {
  gridView = signal<IMyAgent[]>([]);
  agentsLoaded = signal<boolean>(false);

  #apiService = inject(ApiService);
  #alertService = inject(AlertService);
  #spinnerService = inject(SpinnerService);
  #myAgentsService = inject(MyAgentsService);
  #agentService = inject(AgentService);

  constructor() {
    this.#spinnerService.show();
    this.#apiService.getMyAgents().subscribe({
      next: (response) => {
        const updatedData: IMyAgent[] = response.map((item) => {
          return this.#agentService.convertAgentArraysToSting(item);
        });

        this.gridView.set(updatedData);
        this.#myAgentsService.myAgents = response;
        this.agentsLoaded.set(true);
      },
      error: (error: any) => {
        this.#alertService.showAlert({
          message: `Failed to get your agents.`,
          type: AlertEnum.error,
        });
      },
      complete: () => {
        this.#spinnerService.hide();
      }
    });
  }
}
